import * as React from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { StyleDialog, StyledButton } from '../BenevvPopup.styles';
import { Box } from '@mui/material';

export interface BenevvPopupProps {
  title: string;
  open: boolean;
  children?: React.ReactNode;
  onClose: () => void;
  onSubmit?: () => void;
}


export default function BenevvPopup(props: BenevvPopupProps) {
  const { title, open, children, onClose, onSubmit } = props;

  return (
    <div>
      <StyleDialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle sx={{ m: 0, p: 2 }}>
          <Typography sx={{ textAlign: 'center', paddingTop: 2, fontSize: 25 }}>{title}</Typography>
          {onClose ? (
            <IconButton
              aria-label="close"
              onClick={onClose}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          ) : null}
        </DialogTitle>
        <DialogContent>
          {children}
        </DialogContent>
        <DialogActions>
            <StyledButton autoFocus onClick={onSubmit}>
              Confirm
            </StyledButton>
        </DialogActions>
      </StyleDialog>
    </div>
  );
}
